export enum ApiErrorType {
    Warning = "warning",
    Danger = "danger"
  }